'use client';

import { assert, CustomError } from '@core/utils';
import { useQuery } from '@tanstack/react-query';

import { AuthQueryOptions, BOOKMARK_TYPE, UnauthQueryOptions } from '@/api';
import { BookmarkButton } from '@/components/molecule/BookmarkButton';
import { useBookmark } from '@/hooks/useBookmark';
import { useAuthStore } from '@/stores/AuthStore';
import { isBot } from '@/utils/isBot';

interface FestivalBookmarkButtonProps {
  tourId: string;
  festivalName: string;
}

export const FestivalBookmarkButton = ({
  tourId,
  festivalName,
}: FestivalBookmarkButtonProps) => {
  const isLogin = useAuthStore((state) => state.isLogin);

  const feedback = useQuery({
    ...(isLogin
      ? AuthQueryOptions['get:/wello/v2/auth/tour/feedback/{tourId}']
      : UnauthQueryOptions['get:/wello/v2/allows/tour/feedback/{tourId}'])({
      path: { tourId },
    }),
    enabled: isLogin !== undefined && !isBot(),
    select: ({ context }) => {
      assert(context);

      if (!('wishlistYN' in context) || !('wishlistCount' in context))
        throw new CustomError();

      return {
        isBookmarked: context.wishlistYN,
        bookmarkCount: context.wishlistCount,
      };
    },
  });

  const { bookmark } = useBookmark();

  return (
    <BookmarkButton
      bookmarkCount={feedback.data?.bookmarkCount}
      isBookmarked={feedback.data?.isBookmarked}
      onClick={(isBookmarked) => {
        bookmark({
          bookmarkType: BOOKMARK_TYPE.TOUR,
          contentId: tourId,
          isBookmarked,
          contentName: festivalName,
        });
      }}
    />
  );
};
